// helper/apiConfig.js

import axios from 'axios';
import { API_BASE_URL } from 'src/apiConfig';

// API POZIVI ZA STUDENTA

export const fetchSchoolsByCity = async (zip_code) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/schools.php?zip_code=${zip_code}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching schools by city:', error);
    return [];
  }
};

export const fetchStudentsAndCategories = async (params) => {
  const {
    pageSize,
    page,
    selectedTab,
    selectedSchool,
    selectedCity,
    searchQuery,
    signal
  } = params;

  const studentsUrl = new URL(`${API_BASE_URL}/api/students.php`);
  studentsUrl.searchParams.append('limit', pageSize);
  studentsUrl.searchParams.append('offset', (page - 1) * pageSize);

  if (selectedTab !== 'all') {
    studentsUrl.searchParams.append('class', selectedTab);
  }

  if (selectedSchool) {
    studentsUrl.searchParams.append('school_id_filter', selectedSchool.id);
  }

  if (selectedCity) {
    studentsUrl.searchParams.append('city_zip_code', selectedCity.zipcode);
  }

  if (searchQuery) {
    studentsUrl.searchParams.append('search', searchQuery.toLowerCase());
  }

  try {
    const [studentsResponse, categoriesResponse] = await Promise.all([
      axios.get(studentsUrl.toString(), { signal }),
      axios.get(`${API_BASE_URL}/api/categories.php`, { signal })
    ]);

    return {
      students: studentsResponse.data?.students || [],
      total: studentsResponse.data?.total || 0,
      categories: categoriesResponse.data.reduce((acc, category) => {
        acc[category.id] = category.name;
        return acc;
      }, {})
    };
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request canceled', error.message);
    } else {
      console.error('Error fetching students or categories:', error);
    }
    return { students: [], total: 0, categories: {} };
  }
};

export const fetchCities = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/locations.php`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cities:', error);
    return [];
  }
};

export const fetchAllStudents = async (params) => {
  const { selectedTab, selectedSchool, selectedCity, searchQuery } = params;

  const exportUrl = new URL(`${API_BASE_URL}/api/students.php`);

  exportUrl.searchParams.append('export', 1); // This parameter fetches all students

  if (selectedTab !== 'all') {
    exportUrl.searchParams.append('class', selectedTab);
  }

  if (selectedSchool) {
    exportUrl.searchParams.append('school_id_filter', selectedSchool.id);
  }

  if (selectedCity) {
    exportUrl.searchParams.append('city_zip_code', selectedCity.zipcode);
  }

  if (searchQuery) {
    exportUrl.searchParams.append('search', searchQuery.toLowerCase());
  }

  try {
    const response = await axios.get(exportUrl.toString());
    return response.data.students || [];
  } catch (error) {
    console.error('Error fetching students:', error);
    return [];
  }
};
